import { render, staticRenderFns } from "./MessageBodyAuthor.vue?vue&type=template&id=6d4d7bb6&scoped=true&"
import script from "./MessageBodyAuthor.vue?vue&type=script&lang=js&"
export * from "./MessageBodyAuthor.vue?vue&type=script&lang=js&"
import style0 from "./MessageBodyAuthor.vue?vue&type=style&index=0&id=6d4d7bb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4d7bb6",
  null
  
)

export default component.exports